import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {GeneralFormComponent} from '../../general/form/generalForm.component';
import {GroupService} from '../../../services/group.service';
import {MessageService} from '../../../../shared/message.service';
import {QuestionService} from '../../../services/question.service';
import {QuestionControlService} from '../../../services/question-control.service';
import {UserRightGroupUi} from '../../../interfaces/userRightGroupUi';
import {UserRightGroupService} from '../../../services/user-group-right.service';
import {ServiceAnswer, ServiceAnswerAny} from '../../../../shared/service-answer';
import {Group} from '../../../interfaces/group';


@Component({
  selector: 'qm-group-form',
  templateUrl: './group-form.component.html',
  styleUrls: ['./group-form.component.css']
})
export class GroupFormComponent extends GeneralFormComponent<Group> implements OnInit {

  public userRightsGroupUis: UserRightGroupUi[];

  constructor(
    route: ActivatedRoute,
    location: Location,
    messagesService: MessageService,
    router: Router,
    questionService: QuestionService,
    userGroupService: GroupService,
    questionControlService: QuestionControlService,
    private userRightGroupUiService: UserRightGroupService
  ) {
    super(route, userGroupService, location, messagesService, router, questionService, questionControlService,
      {
        entityNameSingular: 'right group',
        entityNamePlural: 'right groups',
        formUrl: 'rightgroup',
        listUrl: 'rightgroups',
        generalFormMetaName: 'group'
      });
  }

  /**
   * If the group being modified is not new then userRightGroupUis are fetched from
   * the service.
   */
  private async fetchUserRightGroups(): Promise<void> {
    if (!this.isNew()) {
      this.userRightsGroupUis = await this.userRightGroupUiService.getRightsOfGroupUis(+this.getIdFromUrl());
    }
  }

  /**
   * When the view is initialized.
   */
  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    await this.fetchUserRightGroups();
  }

  /**
   * Calls super.contextChange and updates the user right array.
   */
  async contextChanged(): Promise<void> {
    await super.contextChanged();
    await this.fetchUserRightGroups();
  }

  /**
   * Saves the entity and the rights.
   */
  async save(): Promise<void> {
    await super.save();
    if (!this.isNew()) {
      try {
        const serviceAnswer: ServiceAnswerAny =
          await this.userRightGroupUiService
            .saveRightsOfGroupUis(+this.getIdFromUrl(), this.userRightsGroupUis);
        if (!serviceAnswer.isOk) {
          const errorMessage = `Storing user rights for group ${+this.getIdFromUrl()} failed. Backend returned \
          HTTP code ${serviceAnswer.errorCode}. Error message: ${serviceAnswer.errorMessage}`;
          console.error(errorMessage);
          this.messagesService.addDanger(errorMessage);
        }
      } catch (error) {
        console.error('Error when storing user rights of group: ' + error);
        this.messagesService.addDanger('Storing user rights of group failed: ' + error);
      }
    }
  }
}
